import { TestCase } from "../../services/evals";

interface UseTestCaseFiltersProps {
  testCases: TestCase[] | undefined;
  selectedTags: string[];
  filteredTestCases: TestCase[];
  selectedTestCaseIds: string[];
  setSelectedTestCaseIds: (ids: string[] | ((prev: string[]) => string[])) => void;
  setSelectedTags: (tags: string[] | ((prev: string[]) => string[])) => void;
}

export const useTestCaseFilters = ({
  testCases,
  filteredTestCases,
  setSelectedTestCaseIds,
  setSelectedTags,
}: UseTestCaseFiltersProps) => {
  const allTags = Array.isArray(testCases)
    ? Array.from(new Set(testCases.flatMap(tc => tc.tags || []))).sort()
    : [];

  const handleToggleTestCase = (id: string) => {
    setSelectedTestCaseIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleToggleTag = (tag: string) => {
    setSelectedTags(prev => (prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]));
  };

  const handleSelectAll = () => {
    const newIds = filteredTestCases.map(tc => tc.id);
    setSelectedTestCaseIds(prev => Array.from(new Set([...prev, ...newIds])));
  };

  const handleDeselectAll = () => {
    const filteredIds = new Set(filteredTestCases.map(tc => tc.id));
    setSelectedTestCaseIds(prev => prev.filter(id => !filteredIds.has(id)));
  };

  return {
    allTags,
    handleToggleTestCase,
    handleToggleTag,
    handleSelectAll,
    handleDeselectAll,
  };
};
